import { combineReducers } from 'redux'
import * as actions from '../actions'
import { mapActionPayloadToState } from '../utils/reducerUtils'
import booleanReducer from '../utils/booleanReducer'

export const initialState = {
  isFetching: false,
  total: 0,
  page: 1,
  hasMore: false,
  items: [],
  totalPages: 0,
}

const isFetching = booleanReducer({
  defaultState: initialState.isFetching,
  trueTypes: [actions.GET_OPPORTUNITIES_REQUEST],
  falseTypes: [
    actions.GET_OPPORTUNITIES_SUCCESS,
    actions.GET_OPPORTUNITIES_FAILURE,
  ],
})

const successProps = mapActionPayloadToState(
  initialState,
  actions.GET_OPPORTUNITIES_SUCCESS,
  ['total', 'page', 'hasMore', 'items'],
)

const totalPages = (
  state = initialState.totalPages,
  { type, payload, meta },
) => {
  if (type === actions.GET_OPPORTUNITIES_SUCCESS) {
    return Math.ceil(payload.total / meta.rows)
  }
  return state
}

export default combineReducers({
  isFetching,
  totalPages,
  ...successProps,
})



// WEBPACK FOOTER //
// ./src/reducers/opportunities.js